var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVendor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5441 15.2166L16.7707 3.44326C16.2774 2.94992 15.5974 2.66992 14.8907 2.66992H5.33073C3.86406 2.66992 2.66406 3.86992 2.66406 5.33659V14.8966C2.66406 15.6033 2.94406 16.2833 3.45073 16.7766L15.2241 28.5499C16.2641 29.5899 17.9574 29.5899 18.9974 28.5499L28.5574 18.9899C29.5974 17.9499 29.5974 16.2699 28.5441 15.2166ZM17.1041 26.6699L5.33073 14.8966V5.33659H14.8907L26.6641 17.1099L17.1041 26.6699Z",
    fill: "#2D4BF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66406 10.6699C9.76863 10.6699 10.6641 9.77449 10.6641 8.66992C10.6641 7.56535 9.76863 6.66992 8.66406 6.66992C7.55949 6.66992 6.66406 7.56535 6.66406 8.66992C6.66406 9.77449 7.55949 10.6699 8.66406 10.6699Z",
    fill: "#2D4BF3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.0bec88c01bba84cd66ce6ee82ac6b549.svg";
export { ForwardRef as ReactComponent };